export default "__VITE_ASSET__D_sMxSWg__"